import { jsx as _jsx } from "react/jsx-runtime";
import { useContactCardSection } from "@/contexts/contact";
import { Rating } from "@gemini/ui";
export const ContactCardRating = ({ marginBottom = "spacing.16", }) => {
    const contactCardSection = useContactCardSection();
    return ((contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.rating) && (_jsx(Rating, { marginBottom: marginBottom, rating: contactCardSection.rating, size: "16" })));
};
